export type MatchString<T extends string, R> = {
    [K in T]: R
}

export function matchString<T extends string, R>(
    matchers: MatchString<T, R>,
): (value: T) => R {
    return (value: T): MatchString<T, R>[T] => matchers[value]
}
